import { Injectable } from '@angular/core';
import { lastValueFrom, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { catchError } from 'rxjs/operators';
import { CompanyFound } from '../models/CompanyFound.model';
import { CompanySearched } from '../models/CompanySearched.model';
import { GS1NotificationLevel, GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class DqeService {

  constructor(private http: HttpClient, private notificationService: GS1NotificationService, private translate: TranslateService) { }

  searchCompany(criteria: string): Observable<CompanySearched[]> {
    let data = '';
    const sirenWithoutSpaces = criteria.split(' ').join('');
    if ((criteria != null) && (criteria !== '') && !isNaN(Number(sirenWithoutSpaces.toString()))) {
      data += `Siren=${criteria}`;
    } else {
      data += `CompanyName=${criteria}`;
    }
    return this.http.get<CompanySearched[]>(`${environment.URL_API}api/Companies/Search?${data}`).pipe(
      catchError(err => {
        return of (err);
      })
    );
  }

  async searchCompanyBySiren(siren: string): Promise<CompanySearched[]> {
    try {
      let data = '';
      const sirenWithoutSpaces = siren.split(' ').join('');
      if ((siren != null) && (siren !== '') && !isNaN(Number(sirenWithoutSpaces.toString()))) {
        data += `Siren=${siren}`;
      }  
      const companies = await lastValueFrom(this.http.get<CompanySearched[]>(`${environment.URL_API}api/Companies/GetCompanyDetailsBySiren?${data}`));
      return companies;
    } catch (err) {
      this.handleError(err, 'GlobalErrors.dqe');
      throw err
    }
  }

  searchCompanyInfo(ref: string): Observable<CompanyFound> {
    return this.http.get<CompanyFound>(`${environment.URL_API}api/Companies/GetDetail?SearchReference=${ref}`).pipe(
      catchError(err => {
        return of(null);
      })
    );
  }

  private sendNotif(message: string, level: GS1NotificationLevel) {
    this.notificationService.addNotification(message, level);
  }

  private handleError(error: any, message?: string): Promise<any> {
    if (message) {
        this.sendNotif(this.translate.instant(message), 'error');
    }
    return error.message || error;
  }
}
